// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import PaginationPresentationPropsDefault from "@insite/mobius/Pagination/presentationProps";
import { resolveColor } from "@insite/mobius/utilities";
import { xBaseTheme } from "@werner/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PaginationPresentationPropsDefault,
        mergeCss: true,
        buttonProps: {
            mergeCss: true,
            ...PaginationPresentationPropsDefault?.buttonProps,
            sizeVariant: "small",
            color: "text.main",
            css: css`
                border: none;
                &:disabled {
                    opacity: 0.5;
                }
                &:not(:disabled):hover {
                    background: none;
                    svg {
                        color: ${({ theme }) => resolveColor("primary", theme)};
                    }
                }
            `,
        },
        currentButton: css`
            &:not(:disabled):hover {
                background: unset;
                border-color: ${({ theme }) => resolveColor("primary", theme)};
                color: ${({ theme }) => resolveColor("primary.contrast", theme)};
            }
        `,
    },
} as xBaseTheme["pagination"];
